export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10937.865dd346.jpg";